export default __webpack_public_path__ + "static/media/empty-state-workpacks.038e4471.svg";